<app-dialog-header [title]="'IMAGE_LIBRARY.UPLOADING_IMAGES.TITLE'" [additionalText]="successCounter / fileList.length" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content *ngIf="uploadingImage" class="p-24">
    <div class="mb-12 status-title" [ngClass]="uploadStatus === 'uploading' || uploadStatus === 'completed' ? 'success' : 'failed'">
        {{
            (uploadStatus === 'uploading'
                ? 'IMAGE_LIBRARY.UPLOADING_IMAGES.STATUS.UPLOADING'
                : uploadStatus === 'canceled'
                ? 'IMAGE_LIBRARY.UPLOADING_IMAGES.STATUS.CANCELED'
                : uploadStatus === 'failed'
                ? 'IMAGE_LIBRARY.UPLOADING_IMAGES.STATUS.FAILED'
                : 'IMAGE_LIBRARY.UPLOADING_IMAGES.STATUS.COMPLETED'
            ) | translate
        }}
    </div>
    <div class="mb-12 status-subtitle">
        <!-- Show status message for upload status uploading, canceled, completed  -->
        {{
            (uploadStatus === 'uploading'
                ? 'IMAGE_LIBRARY.UPLOADING_IMAGES.STATUS.UPLOADING_MESSAGE'
                : uploadStatus === 'canceled'
                ? 'IMAGE_LIBRARY.UPLOADING_IMAGES.STATUS.CANCELED_MESSAGE'
                : uploadStatus === 'completed'
                ? 'IMAGE_LIBRARY.UPLOADING_IMAGES.STATUS.COMPLETED_MESSAGE'
                : ''
            ) | translate
        }}
        <!-- Show only response error.message if status is failed -->
        <span *ngIf="uploadStatus === 'failed'">
            {{
                (uploadingImage.error.error.errors && uploadingImage.error.error.errors.file && uploadingImage.error.error.errors.file.message === 'file_too_large'
                    ? 'IMAGE_LIBRARY.UPLOADING_IMAGES.STATUS.RESPONSE.FILE_TOO_LARGE'
                    : uploadingImage.error.error.errors && uploadingImage.error.error.errors.file && uploadingImage.error.error.errors.file.message === 'invalid_mime_type'
                    ? 'IMAGE_LIBRARY.UPLOADING_IMAGES.STATUS.RESPONSE.INVALID_MIME_TYPE'
                    : uploadingImage.error.message === 'original_image_not_found'
                    ? 'IMAGE_LIBRARY.UPLOADING_IMAGES.STATUS.RESPONSE.ORGINAL_NOT_FOUND'
                    : 'IMAGE_LIBRARY.UPLOADING_IMAGES.STATUS.RESPONSE.NOT_UPLOADED_IMAGE'
                ) | translate
            }}
        </span>
    </div>
    <div class="mb-12 file-name">{{ uploadingImage.fileName }}</div>
    <mat-progress-bar
        attr.aria-label="{{ 'GENERAL.LABEL.PROGRESS_BAR' | translate }}"
        class="mb-8"
        mode="determinate"
        [color]="uploadStatus === 'failed' || uploadStatus === 'canceled' ? 'warn' : 'accent'"
        [value]="uploadingImage.percentDone"
    ></mat-progress-bar>
    <div class="file-percentage" [ngClass]="uploadStatus === 'uploading' || uploadStatus === 'completed' ? 'success' : 'failed'">{{ uploadingImage.percentDone }}%</div>
    <div class="file-list-container status-subtitle" *ngIf="uploadStatus === 'canceled' || uploadStatus === 'failed'">
        <h4 class="mb-12 mt-0">{{ 'IMAGE_LIBRARY.UPLOADING_IMAGES.STATUS.NOT_UPLOADED_IMAGES' | translate }}</h4>
        <div *ngFor="let file of fileList">
            <span class="mb-4 file" *ngIf="!file.uploaded">
                {{ file.name }}
            </span>
        </div>
    </div>
</div>

<div mat-dialog-actions class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-white-button
        [disabled]="myImageApiService.cancelUploadingImages || tenantLibraryApiService.cancelUploadingImages || uploadStatus !== 'uploading'"
        [label]="'GENERAL.BUTTON.CANCEL'"
        (onClick)="cancelUploadImages()"
    ></app-white-button>
</div>
